import { render, staticRenderFns } from "./approveChangeRequest.vue?vue&type=template&id=6d082133&scoped=true&"
import script from "./approveChangeRequest.vue?vue&type=script&lang=js&"
export * from "./approveChangeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d082133",
  null
  
)

export default component.exports